import { formatDateTime } from '@formosa/shared/utils/formatDateTime';
import {
  formatAmount,
  formatOptionalId,
  formatWithdrawStatus,
  formatFirstWithdraw,
  formatFirstBinding,
} from './withdrawConstants';

function InfoItem({ label, value }) {
  return (
    <p className="kyc-audit-info__item">
      <span className="kyc-audit-info__label">{label}：</span>
      <span>{value ?? '—'}</span>
    </p>
  );
}

/**
 * 提現訂單詳情（唯讀）。
 */
export default function WithdrawDetailModal({ open, row, onClose }) {
  if (!open || !row) {
    return null;
  }

  return (
    <div className="admin-modal-overlay" role="presentation" onClick={onClose}>
      <div
        className="admin-modal admin-modal--wide"
        role="dialog"
        aria-modal="true"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="admin-modal__header">
          <h3>詳情</h3>
          <button type="button" className="admin-modal__close" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="admin-modal__body">
          <div className="kyc-audit-info">
            <InfoItem label="提現單號" value={formatOptionalId(row.id)} />
            <InfoItem label="商戶單號" value={row.thirdRecordCode} />
            <InfoItem label="用戶 ID" value={formatOptionalId(row.memberId)} />
            <InfoItem label="幣種" value={row.currencyName} />
            <InfoItem label="申請金額" value={formatAmount(row.amount)} />
            <InfoItem label="手續費" value={formatAmount(row.fee)} />
            <InfoItem label="到帳金額" value={formatAmount(row.receivedAmount ?? row.withdrawalAmount)} />
            <InfoItem label="提現地址" value={row.address} />
            <InfoItem label="狀態" value={formatWithdrawStatus(row.status)} />
            <InfoItem label="是否首提" value={formatFirstWithdraw(row.behaviorRemark)} />
            <InfoItem label="首綁/修改" value={formatFirstBinding(row.firstBindingOrModified)} />
            <InfoItem label="鎖定狀態" value={row.isLock ? '已鎖定' : '未鎖定'} />
            <InfoItem label="申請時間" value={formatDateTime(row.createTime)} />
            <InfoItem label="回調時間" value={formatDateTime(row.callbackDate)} />
            <InfoItem label="備註" value={row.remark} />
            <InfoItem label="失敗原因" value={row.failedInfo} />
          </div>
        </div>
        <div className="admin-modal__footer">
          <button type="button" className="btn btn-secondary" onClick={onClose}>
            關閉
          </button>
        </div>
      </div>
    </div>
  );
}
